import { applyRate, type Cents } from "./money";

/**
 * How tax is applied to a quote.
 * - iva16: Mexican VAT, 16 %, shown as a separate line.
 * - exempt: no tax (clients outside Mexico, export of services).
 */
export type TaxMode = "iva16" | "exempt";

export const TAX_MODES: readonly TaxMode[] = ["iva16", "exempt"];

const IVA_RATE = 0.16;

/** Suggests the tax mode from the client's country (ISO 3166-1 alpha-2). */
export function suggestTaxMode(countryCode: string): TaxMode {
  return countryCode.toUpperCase() === "MX" ? "iva16" : "exempt";
}

export function taxRate(mode: TaxMode): number {
  return mode === "iva16" ? IVA_RATE : 0;
}

export function computeTax(subtotal: Cents, mode: TaxMode): Cents {
  return applyRate(subtotal, taxRate(mode));
}
